import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { MemberModel } from "../../pages/settings/members/add-members/add-members";
import { FirestoreService } from "../../../shared/api/firebase/firestoreService";
import { FirestoreCollectionReference } from "../../../shared/api/firebase/references";

interface MmeberDetail {
  data?: MemberModel[] | null;
  loading: boolean;
  error: string | null;
}

const initialState: MmeberDetail = {
  data: null,
  loading: false,
  error: null,
};

const memberSlice = createSlice({
  name: "member",
  initialState,
  reducers: {
    fetchMemberStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchMemberSuccess(state, action: PayloadAction<MemberModel[]>) {
      state.data = action.payload;
      state.loading = false;
    },
    fetchMemberFailure(state, action: PayloadAction<string>) {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const { fetchMemberStart, fetchMemberSuccess, fetchMemberFailure } =
  memberSlice.actions;

export const fetchInvitedMembers = () => async (dispatch: any) => {
  dispatch(fetchMemberStart());
  try {
    const unsubscribe = FirestoreService.listenToAllDocuments<MemberModel>(
      FirestoreCollectionReference.members(),
      (members) => {
        dispatch(fetchMemberSuccess(members));
      },
      (error) => {
        dispatch(fetchMemberFailure(error.message));
      },
    );

    return unsubscribe;
  } catch (error: any) {
    dispatch(fetchMemberFailure(error.message));
  }
};

export default memberSlice.reducer;
